export class Filter {
    constructor(){
        this.wards = [];
        this.orderState =  [0,1,2];

        if(localStorage.getItem('report.generation') == 'PDF'){
            this.state_list = [
                {value: 0, id: [0, 1], description: "Ingresadas"}, 
                {value: 1, id: [2, 3, 4, 5, 6, 7], description: "En curso"},
                {value: 2, id: [8, 9], description: "Finalizadas"}]
        }else{
            this.state_list = [
                {value: 0, id: [0, 1], description: "Ingresadas"}, 
                {value: 1, id: [2, 3, 4, 5, 6], description: "En curso"},
                {value: 2, id: [7, 8, 9], description: "Finalizadas"}]
        }

        
            
       
    }
    
    private _name: string;    
    private _surname: string;    
    private _dni: string;
    private _hc: string;
    searchOnlyByNameOrSurname;

    wards: any[];
    orderState: number[];

    /*generationType: this.userService.getSystemProperty('report.generation')*/
    state_list: any[];
    orderId: string;
    startDate: any;
    endDate: any;
    patientIds: number[];
    public group: number;

    public getStartDate = function() {
        return this.startDate.toLocaleDateString();
    };
    public getEndDate = function() {
        return this.endDate.toLocaleDateString();
    };

    public get name(): string {
        return this._name;
    }
    public set name(value: string) {
        if(value != ""){
            this._name = value;
        } else {
            this._name = undefined;
        }
    }

    public get surname(): string {
        return this._surname;
    }
    public set surname(value: string) {
        if(value != ""){
            this._surname = value;
        }else{
            this._surname = undefined;
        }
    }

    public get dni(): string {
        return this._dni;
    }
    public set dni(value: string) {
        if(value != ""){
            this._dni = value;
        } else {
          this._dni = undefined;  
        } 
    }

    public get hc(): string {
        return this._hc;
    }
    public set hc(value: string) {
        if(value != ""){
            this._hc = value;
        } else {
          this._hc = undefined;  
        }       

    }



    public minDate: number;
    
    public hasPatient(){
        return this.dni != undefined  || this.name!= undefined || 
        this.surname != undefined || this.hc != undefined;
        
    }

    public hasOrder(allSelectedWard, allSelectedState ){
        let hasProtocol = this.orderId != undefined;
        let today = new Date().toLocaleDateString()
        let hasDate = this.startDate?.toLocaleDateString() != today && this.startDate?.toLocaleDateString() != undefined 
        || this.endDate?.toLocaleDateString() != today && this.endDate?.toLocaleDateString() != undefined ;
        
        return hasProtocol || !allSelectedWard || !allSelectedState || hasDate;
    }

    public get hasProtocol(){
        return this.orderId != undefined;
    }

    public isValid(){
        let hasProtocol = this.orderId != undefined;
        let hasDate = this.startDate != undefined && this.endDate != undefined;
        let hasPatient;
        if(this.searchOnlyByNameOrSurname == 0){
            hasPatient = this.dni != undefined  || (this.name!= undefined && this.surname != undefined)
             || this.hc != undefined;
        } else{
            hasPatient = this.hasPatient()
        }

        if(this.hasPatient() || hasProtocol){
            this.startDate = undefined;
            this.endDate = undefined;
        }


        return hasProtocol || hasDate || hasPatient;
    }
  };
